import { Ng1StateDeclaration } from '@uirouter/angularjs';

import * as Resolve from '../Resolve';
import { Roles, editWidgetState, editGroupWidgetState } from '../../common/constants';

const states: Ng1StateDeclaration[] = [
    {
        name: editWidgetState,
        url: '/:dashboardGuid/editWidget/:widgetGuid/:beginDate/:endDate',
        component: 'wtEditWidgetState',
        resolve: {
            auth: Resolve.authResolve,
            connected: Resolve.connectedResolve,
            roles: Resolve.rolesResolve([Roles.master, Roles.engineer])
        },
        data: {
            backButtonDisabled: () => false,
            backButtonVisibility: () => true,
            displayName: 'Edit widget',
            editButtonDisabled: () => true,
            editButtonVisibility: () => true,
            editRoles: [Roles.master, Roles.engineer],
            visible: false,
        }
    }, {
        name: editGroupWidgetState,
        url: '/:groupGuid/editGroupWidget/:widgetGuid/:beginDate/:endDate',
        component: 'wtEditGroupWidgetState',
        resolve: {
            auth: Resolve.authResolve,
            connected: Resolve.connectedResolve,
            roles: Resolve.rolesResolve([Roles.master, Roles.engineer])
        },
        data: {
            backButtonDisabled: () => false,
            backButtonVisibility: () => true,
            displayName: 'Edit widget',
            editButtonDisabled: () => true,
            editButtonVisibility: () => true,
            editRoles: [Roles.master, Roles.engineer],
            visible: false,
        }
    }
];

export default states;